import { IHttpService, IQService } from 'angular';
import { IBitUrlBuilder } from '../../../shared/services/bitUrlBuilder/bitUrlBuilder.factory';

export type IBitApi = ReturnType<typeof bitApiFactory>;

/* @ngInject */
export function bitApiFactory(
  $http: IHttpService,
  $q: IQService,
  geoLocation,
  bitUrlBuilder: IBitUrlBuilder,
) {
  const fetchEvents = (artistName) =>
    $http.get<any>(bitUrlBuilder.buildEventUrl(artistName), { cache: true });

  return {
    getEvents,
    getLocalEvents,
  };

  function getEvents(artistName) {
    return fetchEvents(artistName).then(function (response) {
      if (response.data.errors) {
        return [];
      }
      return response.data;
    });
  }

  function getLocalEvents(artistName) {
    return $q.all([geoLocation.getLocation(), fetchEvents(artistName)]).then(
      function ([{ coords }, response]) {
        if (response.data.errors) {
          return [];
        }
        const R = 6371; // earth radius in km
        const MAX_DISTANCE = 80; // 80 km ~ 50 miles – the radius we consider it "local"
        const toRad = (deg) => (Math.PI * deg) / 180;
        const fi1 = toRad(coords.latitude);
        const lambda1 = toRad(coords.longitude);
        return response.data.filter(({ venue }) => {
          // Haversine formula
          // https://en.wikipedia.org/wiki/Haversine_formula
          const fi2 = toRad(venue.latitude);
          const lambda2 = toRad(venue.longitude);
          const distance =
            2 *
            R *
            Math.asin(
              Math.sqrt(
                Math.pow(Math.sin((fi2 - fi1) / 2), 2) +
                  Math.cos(fi1) *
                    Math.cos(fi2) *
                    Math.pow(Math.sin((lambda2 - lambda1) / 2), 2),
              ),
            );
          return distance <= MAX_DISTANCE;
        });
      },
      function () {
        return [];
      },
    );
  }
}
